import React, { useEffect, useState } from "react";
import { Get } from "../../config/api/get";
import { BASE_URL, REPORT } from "../../config/constants";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import styles from './reportDetails.module.css';
import axios from "axios";

const StudentCertificate = ({ studentData }) => {
  const token = useSelector((state) => state.user.userToken);
  
  const generateCertificate = async (download = true, view = true) => {
    try {
      const response = await axios.get(`${BASE_URL}/certificate/generate`, {
        params: { name: studentData?.firstName },
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/pdf',
        },
        responseType: 'blob', // Important for handling binary data like PDFs
      });

      // Create a blob from the PDF response
      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });

      // Create a URL for the blob
      const pdfUrl = window.URL.createObjectURL(pdfBlob);

      // Open the PDF in a new tab
      if (view) {
        window.open(pdfUrl, '_blank');
      }

      if (download) {
        // Optional: Automatically trigger the download
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.setAttribute('download', `${studentData?.firstName}-certificate.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.error('Error generating certificate:', error);
      // Handle the error (e.g., show a message to the user)
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>Student Certificate Eligibility</h2>
      
      <div className={styles.studentInfo}>
        <h3 className={styles.studentName}>{studentData?.firstName}</h3>
        <p className={styles.email}>Email: {studentData?.email}</p>
      </div>
      
      <div className={styles.coursesList}>
        <h4 className={styles.coursesHeading}>Courses</h4>
        {studentData?.courses.length > 0 ? (
          studentData?.courses.map((course) => (
            <div key={course._id} className={styles.courseItem}>
              <h5 className={styles.courseTitle}>{course.title}</h5>
              {course.quizes.length > 0 ? (
                course.quizes.map((quiz) => (
                  <div key={quiz._id} className={styles.quizItem}>
                    <p className={styles.quizTitle}>Quiz Title: {quiz.title}</p>
                    <p className={styles.quizDetail}>Passing Percentage: {quiz.passingPercentage}%</p>
                    <p className={styles.quizDetail}>Total Score: {quiz.totalScore}</p>
                    {quiz.attempts.map((attempt) => (
                      <div key={attempt._id} className={styles.attemptItem}>
                        <p className={styles.attemptDetail}>Score: {attempt.score}</p>
                        <p className={styles.attemptDetail}>Status: {attempt.status}</p>
                      </div>
                    ))}
                  </div>
                ))
              ) : (
                <p className={styles.noQuiz}>No quizzes available for this course.</p>
              )}
              <p className={`${styles.eligibilityStatus} ${course.eligibleForCertificate ? styles.eligible : styles.notEligible}`}>
                {course.eligibleForCertificate ? 'Eligible for Certificate' : 'Not Eligible for Certificate'}
              </p>
              {course.eligibleForCertificate && (
                <div className={styles.buttonContainer}>
                  <button 
                    className={styles.certificateButton} 
                    onClick={generateCertificate}
                  >
                    Generate Certificate
                  </button>
                </div>
              )}
            </div>
          ))
        ) : (
          <p className={styles.noCourses}>No courses enrolled.</p>
        )}
      </div>
    </div>
  );
};

function ReportDetails() {
  const token = useSelector((state) => state.user.userToken);
  const [, setLoading] = useState(false);
  const {id} = useParams()
  const [user,setUser]=useState(null);

  useEffect(() => {
    getUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  const getUser = async () => {
    setLoading(true);
    const user = await Get(`${REPORT.getStudentReport}`, token, {studentId: id});

    console.log("userss",user)
    debugger
    setUser(user);
    setLoading(false);
  };


  return (
    <StudentCertificate studentData={user?.length && user[0]} />
  )

}
export default ReportDetails;
